import { MediaType } from '@wix/ambassador-media-site-media-v1-file-descriptor/types';
import { mapSecureVideo } from './files/video/SecureVideo.mappers';
import { mapVideo } from './files/video/Video.mappers';
import { mapAudioFile } from './files/audio/Audio.mappers';
import { mapSecureAudioFile } from './files/audio/SecureAudio.mappers';
import { mapPictureFile } from './files/picture/Picture.mappers';
import { mapSecurePictureFile } from './files/picture/SecurePicture.mappers';
import { mapArchive, mapSecureArchive } from './files/Archive.mappers';
import { mapDocument, mapSecureDocument } from './files/Document.mappers';
import { mapModel3d } from './files/Model3D.mappers';
import { mapShape } from './files/Shape.mappers';
import { mapBaseFile } from './files/BaseFile.mappers';
import { mapSwf } from './files/Swf.mappers';
import { mapSiteIcon } from './files/SiteIcon.mappers';
const commonMappers = {
  [MediaType.FLASH]: mapSwf,
  [MediaType.ICON]: mapSiteIcon,
  [MediaType.FONT]: null,
  // font are not showing in Media Manager
  [MediaType.OTHER]: null,
  [MediaType.UNKNOWN]: null
};
const privateFileMappers = {
  ...commonMappers,
  [MediaType.VIDEO]: mapSecureVideo,
  [MediaType.DOCUMENT]: mapSecureDocument,
  [MediaType.ARCHIVE]: mapSecureArchive,
  [MediaType.IMAGE]: mapSecurePictureFile,
  [MediaType.AUDIO]: mapSecureAudioFile,
  [MediaType.MODEL3D]: null,
  [MediaType.VECTOR]: null
};
const publicFileMappers = {
  ...commonMappers,
  [MediaType.VIDEO]: mapVideo,
  [MediaType.DOCUMENT]: mapDocument,
  [MediaType.ARCHIVE]: mapArchive,
  [MediaType.IMAGE]: mapPictureFile,
  [MediaType.AUDIO]: mapAudioFile,
  [MediaType.MODEL3D]: mapModel3d,
  [MediaType.VECTOR]: mapShape
};
export const mapFile = (file, baseFileParams) => {
  if (!file.mediaType) {
    throw new Error('[mapping] mediaType is missing');
  }
  const mapper = file.private ? privateFileMappers[file.mediaType] : publicFileMappers[file.mediaType];
  if (!mapper) {
    throw new Error(`[mapping] no mapping for mediaType: ${file.mediaType}`);
  }
  const baseFile = mapBaseFile(file, baseFileParams);
  return mapper(file, baseFile);
};
export const mapFiles = (files, baseFileParams, onError) => {
  const mappedFiles = [];
  for (const file of files) {
    try {
      mappedFiles.push(mapFile(file, baseFileParams));
    } catch (error) {
      onError(error, 'mapFiles', {
        fileId: file.id
      });
    }
  }
  return mappedFiles;
};
//# sourceMappingURL=File.mappers.js.map